import { useSelector } from "react-redux";
import ComponentsRoutesTypeStudent from "../../../student/enums/ComponentsRoutesTypeStudent";
import ComponentsRoutesTypeTeacher from "../../../teacher/enums/ComponentsRoutesTypeTeacher";

const DynamicComponent = ({ compType, tab }) => {

    const { isStudent } = useSelector(state => state.auth);
    const Component = isStudent ? ComponentsRoutesTypeStudent[compType] : ComponentsRoutesTypeTeacher[compType]

    return (
        Component ? <Component {...tab} /> : null
    )
};

export default DynamicComponent;